import { render } from "./AddCompany.vue?vue&type=template&id=6202ee18&ts=true"
import script from "./AddCompany.vue?vue&type=script&lang=ts"
export * from "./AddCompany.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__